export default "/images/topdanmark-min.webp?5e2986afc28c138d4783a1abce77fc46";